import React, { Component } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Snackbar from "@material-ui/core/Snackbar";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import AddBoxIcon from "@material-ui/icons/AddBox";
import TextField from "@material-ui/core/TextField";
import {
  DeleteProduct,
  GetProductsByBrandAndGoodType,
  GetAllBrands,
  GetGoodsTypes,
  GetProducts,
  FilterProductByName,
} from "../../fetchs";
import { Link } from "react-router-dom";
import { Button, Grid } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import AlertDialog from "../Prompt/alert-dialog.component";
import CircularProgress from "@material-ui/core/CircularProgress";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./product-list.styles.css";

const headCells = [
  { id: "number", numeric: false, disablePadding: true, label: "شماره" },
  { id: "pic", numeric: false, disablePadding: true, label: "عکس کالا" },
  { id: "name", numeric: false, disablePadding: true, label: "نام" },
  { id: "brand", numeric: true, disablePadding: false, label: "برند" },
  { id: "goodType", numeric: true, disablePadding: false, label: "نوع کالا" },
  {
    id: "price",
    numeric: false,
    disablePadding: true,
    label: "مشاهده لیست قیمت ها",
  },
  {
    id: "price",
    numeric: false,
    disablePadding: true,
    label: "افزودن به جشنواره",
  },
  { id: "tools", numeric: false, disablePadding: true, label: "تغییرات" },
];

export default class ProductList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      page: 0,
      rowsPerPage: 20,
      rowsLength: 0,
      rows: [],
      brands: [],
      goodTypes: [],
      filterBrandId: "",
      filterGoodTypeId: "",
      alertDialog: false,
      deleteId: null,
      loading: false,
      openSnackbar: false,
      errorMessage: "",
    };
  }

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  componentDidMount() {
    this.getProductsFromServer();
    this.getBrandsAndGoodTypesFromServer();
  }
  getProductsFromServerByName = () => {
    if (this.state.name.length > 0) {
      FilterProductByName(this.state.name)
        .then((response) => {
          this.setState({ loading: false });
          return response.json();
        })
        .then((responseJson) => {
          if (responseJson.Message)
            this.setState({
              errorMessage: responseJson.Message,
              openSnackbar: true,
            });
          else
            this.setState({
              rows: responseJson.data,
              rowsLength: responseJson.count,
            });
        })
        .catch((error) => {
          this.setState({ loading: false });
          console.log(error);
        });
    }
  };

  getProductsFromServer = () => {
    this.setState({ loading: true });
    if (!this.state.filterGoodTypeId || !this.state.filterBrandId) {
      GetProducts(this.state.page, this.state.rowsPerPage)
        .then((response) => {
          this.setState({ loading: false });
          return response.json();
        })
        .then((responseJson) => {
          if (responseJson.Message)
            this.setState({
              errorMessage: responseJson.Message,
              openSnackbar: true,
            });
          else
            this.setState({
              rows: responseJson.data,
              rowsLength: responseJson.count,
            });
        })
        .catch((error) => {
          this.setState({ loading: false });
          console.error(error);
        });
    } else {
      GetProductsByBrandAndGoodType(
        this.state.page,
        this.state.rowsPerPage,
        this.state.filterBrandId,
        this.state.filterGoodTypeId
      )
        .then((response) => {
          this.setState({ loading: false });
          return response.json();
        })
        .then((responseJson) => {
          if (responseJson.Message)
            this.setState({
              errorMessage: responseJson.Message,
              openSnackbar: true,
            });
          else
            this.setState({
              rows: responseJson.data,
              rowsLength: responseJson.count,
            });
        })
        .catch((error) => {
          this.setState({ loading: false });
          console.log(error);
        });
    }
  };

  getBrandsAndGoodTypesFromServer = () => {
    GetAllBrands()
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ brands: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });

    GetGoodsTypes()
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ goodTypes: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handleBrandChange = (e) => {
    this.setState({ filterBrandId: e.target.value }, () => {
      this.getProductsFromServer();
    });
  };

  handleCategoryChange = (e) => {
    this.setState({ filterGoodTypeId: e.target.value }, () => {
      this.getProductsFromServer();
    });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      this.getProductsFromServer();
    });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 }, () => {
      this.getProductsFromServer();
    });
  };

  handleDelete = () => {
    this.setState({ alertDialog: false, loading: true });
    DeleteProduct(this.state.deleteId)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status === 200) toast.success("محصول با موفقیت حذف شد");
        else toast.error("خطای حذف محصول");
        this.getProductsFromServer();
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handlePrepareDelete = (id) => {
    this.setState({ deleteId: id, alertDialog: true });
  };

  handleCloseDialog = () => {
    this.setState({ alertDialog: false });
  };

  emptyRows = () =>
    this.state.rowsPerPage -
    Math.min(
      this.state.rowsPerPage,
      this.state.rowsLength - this.state.page * this.state.rowsPerPage
    );

  render() {
    return (
      <div className="root">
        <Paper className="paper">
          <Toolbar>
            <Grid
              spacing={2}
              container
              justify="flex-center"
              alignContent="center"
            >
              <Grid item>
                <div className="title">
                  {
                    <Typography variant="h6" id="tableTitle">
                      لیست محصولات
                    </Typography>
                  }
                </div>
              </Grid>
              <Grid item xs={12} sm={2}>
                <Link to="/main/product" className="link">
                  <Button variant="contained" color="primary">
                    ساخت محصول جدید
                  </Button>
                </Link>
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormControl
                  variant="outlined"
                  className="formControl"
                  fullWidth
                >
                  <InputLabel htmlFor="outlined-age-simple">برند</InputLabel>
                  <Select
                    value={this.state.filterBrandId}
                    onChange={this.handleBrandChange}
                    labelWidth={100}
                    inputProps={{
                      name: "brandSelect",
                      id: "outlined-age-simple",
                    }}
                  >
                    <MenuItem value="">
                      <em>تمام برندها</em>
                    </MenuItem>
                    {this.state.brands.map((brand) => {
                      return <MenuItem value={brand.id}>{brand.name}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormControl
                  variant="outlined"
                  className="formControl"
                  fullWidth
                >
                  <InputLabel htmlFor="outlined-age-simple">
                    دسته بندی
                  </InputLabel>
                  <Select
                    value={this.state.filterGoodTypeId}
                    onChange={this.handleCategoryChange}
                    labelWidth={100}
                    inputProps={{
                      name: "categorySelect",
                      id: "outlined-age-simple",
                    }}
                  >
                    <MenuItem value="">
                      <em>تمام دسته بندی ها</em>
                    </MenuItem>
                    {this.state.goodTypes.map((category) => {
                      return (
                        <MenuItem value={category.id}>{category.name}</MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>

              <Grid
                container
                alignContent="center"
                alignItems="center"
                xs={12}
                sm={4}
              >
                <Grid item>
                  <TextField
                    placeholder="نام کاربر را وارد کنید..."
                    onChange={(e) => this.setState({ name: e.target.value })}
                    id="name"
                    label="نام"
                    value={this.state.name}
                  />
                </Grid>
                <Grid item>
                  <Button
                    onClick={() => this.getProductsFromServerByName()}
                    margin="normal"
                    variant="contained"
                    color="primary"
                  >
                    جستجو
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Toolbar>
          <div className="tableWrapper">
            <Table
              className="table"
              aria-labelledby="tableTitle"
              size={"medium"}
            >
              <TableHead>
                <TableRow>
                  {headCells.map((headCell) => (
                    <TableCell
                      key={headCell.id}
                      align={"center"}
                      padding={headCell.disablePadding ? "none" : "default"}
                    >
                      <TableSortLabel active={false}>
                        {headCell.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.rows.map((row, index) => {
                  return (
                    <TableRow hover tabIndex={-1} key={row.id}>
                      <TableCell align="center">
                        {this.state.page * this.state.rowsPerPage + index + 1}
                      </TableCell>
                      <TableCell align="center">
                        <img
                          src={`http://test.asa-oil.ir//${row.imageAddress}`}
                          alt={row.name}
                          style={{ maxHeight: "50px", maxWidth: "50px" }}
                        />
                      </TableCell>
                      <TableCell align="center">{row.name}</TableCell>
                      <TableCell align="center">{row.brand}</TableCell>
                      <TableCell align="center">{row.goodsType}</TableCell>
                      <TableCell align="center">
                        <Link to={`/main/pricebyid/${row.id}`}>
                          <VisibilityIcon />
                        </Link>
                      </TableCell>
                      <TableCell align="center">
                        <Link to={`/main/festivaladd/${row.id}`}>
                          <AddBoxIcon />
                        </Link>
                      </TableCell>
                      <TableCell align="center" style={{ width: "105px" }}>
                        <Link to={`/main/product/${row.id}`}>
                          <EditIcon color="primary" />
                        </Link>
                        <DeleteIcon
                          className="deleteIcon"
                          onClick={() => this.handlePrepareDelete(row.id)}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
                {this.emptyRows > 0 && (
                  <TableRow style={{ height: 49 * this.emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          {this.state.loading && (
            <CircularProgress size={24} className="buttonProgress" />
          )}
          <TablePagination
            rowsPerPageOptions={[20, 50, 100]}
            component="div"
            count={this.state.rowsLength}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            backIconButtonProps={{
              "aria-label": "previous page",
            }}
            nextIconButtonProps={{
              "aria-label": "next page",
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
        <AlertDialog
          open={this.state.alertDialog}
          title={`اخطار`}
          body={`آیا از حذف محصول اطمینان دارید؟`}
          handleYes={this.handleDelete}
          handleNo={this.handleCloseDialog}
        />
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          autoHideDuration={3000}
          open={this.state.openSnackbar}
          ContentProps={{
            "aria-describedby": "message-id",
            class:
              "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
          }}
          message={<span id="message-id"> {this.state.errorMessage} </span>}
          onClose={() => this.handleCloseSnackbar(false)}
        />
      </div>
    );
  }
}
